import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Row, Col } from "react-bootstrap"
import ScrollAnimation from "react-animate-on-scroll"
import SocialConnectionImg from "../../images/social-connections.svg"
import CmsImg from "../../images/cms.svg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRight } from "@fortawesome/free-solid-svg-icons"
import EssentialsPageStyle from "./essentials-page.module.scss"

const SocialCms = () => (
    <StaticQuery query={graphql`
        query SocialAndCMS {
            contentfulTheEssentialsPage{
                essentialsReference{
                 sectionContent4{
                      subtitle{
                        subtitle
                      }
                      sectionParagraph{
                        json
                      }
                    }
                    sectionContent5{
                        subtitle{
                          subtitle
                        }
                        sectionParagraph{
                          json
                        }
                    }
                }
            }
        }
    `}
    render={data =>(
    <div className={EssentialsPageStyle.sectionDiv}>
        <Row>
            <Col className={EssentialsPageStyle.socialCmsCol1} md={6}>
                <h3 className={EssentialsPageStyle.sectionTitle}>{data.contentfulTheEssentialsPage.essentialsReference.sectionContent4.subtitle.subtitle}</h3>
                <div className={EssentialsPageStyle.sectionDescription}>
                    {documentToReactComponents(data.contentfulTheEssentialsPage.essentialsReference.sectionContent4.sectionParagraph.json)}
                </div>
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true}>
                    <SocialConnectionImg className={EssentialsPageStyle.socialConnectionImg} />
                </ScrollAnimation>
            </Col>
            <Col className={EssentialsPageStyle.socialCmsCol2} md={6}>
                <h3 className={EssentialsPageStyle.sectionTitle}>{data.contentfulTheEssentialsPage.essentialsReference.sectionContent5.subtitle.subtitle}</h3>
                <div className={EssentialsPageStyle.sectionDescription}>
                    {documentToReactComponents(data.contentfulTheEssentialsPage.essentialsReference.sectionContent5.sectionParagraph.json)}
                </div>
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true}>
                    <CmsImg className={EssentialsPageStyle.cmsImg} />
                </ScrollAnimation>
            </Col>
        </Row>
        <Row className={EssentialsPageStyle.essentialsLinksRow1}>
            <Col className={EssentialsPageStyle.essentialsLinksCol} md={12}>
                <span className={EssentialsPageStyle.activeLink}>The Essentials</span>
                <Link to="/mobile-first" className={EssentialsPageStyle.essentialsLinks}>Mobile First</Link>
                <Link to="/engaging-menu" className={EssentialsPageStyle.essentialsLinks}>Engaging Menu</Link>
                <Link to="/convenient-booking" className={EssentialsPageStyle.essentialsLinks}>Convenient Booking</Link>
            </Col>
        </Row>
        <Row className={EssentialsPageStyle.essentialsLinksRow2}>
            <Col className={EssentialsPageStyle.essentialsLinksMobileCol} xs={12}>
                <Link to="/mobile-first" className={EssentialsPageStyle.essentialsLinksMobile}>Next <FontAwesomeIcon icon={faArrowRight} className={EssentialsPageStyle.chevronIcons} /></Link>
            </Col>
        </Row>
    </div>
    )}
    />
)

export default SocialCms